<div class="selections-container">
  <label *ngIf="showTitle" class="info-header">{{title}}</label>
  <div class="spacer-small is-hidden-mobile"></div>
  <table class="is-hidden-mobile">
    <tr>
      <td class="info-label">{{primaryUseLabel}} <span class="info-text">{{primaryUse}}</span></td>
      
    </tr>
    <div class="spacer-xx-small"></div>
    <tr>
      <td class="info-label">{{needToRunLabel}} <span class="info-text">{{needToRun}}</span></td>
    </tr>
    <div class="spacer-xx-small"></div>
    <tr>
      <td class="info-label">{{useCaseLabel}} <span class="info-text">{{useCase}}</span></td>
    </tr>
    <div class="spacer-xx-small"></div>
    <tr>
      <td class="info-label">{{brandsLabel}} <span class="info-text">{{brands}}</span></td>
    </tr>
  </table>
  <div class="is-hidden-tablet selections-mobile">
    <div>
      <div class="info-label">
        {{primaryUseLabel}}
        <span class="info-text"> {{primaryUse}}</span>
      </div>
      <div class="buffer-small"></div>
    </div>
    <div>
      <div class="info-label">
        {{needToRunLabel}}
        <span class="info-text"> {{needToRun}}</span>
      </div>
      <div class="buffer-small"></div>
    </div>
    <div>
      <div class="info-label">
        {{useCaseLabel}}
        <span class="info-text"> {{useCase}}</span>
      </div>
      <div class="buffer-small"></div>
    </div>
    <div>
      <div class="info-label">
        {{brandsLabel}}
        <span class="info-text"> {{brands}}</span>
      </div>
    </div>
  </div>
</div>
